export const translations = {
  cancelButton: {
    pt: 'Cancelar',
    en: 'Cancel',
    es: 'Cancelar',
    de: 'Abbrechen',
  },
  submitButton: {
    pt: 'Criar rota',
    en: 'Create route',
    es: 'Crear ruta',
    de: 'Route erstellen',
  },
}